import { render, staticRenderFns } from "./VeterinarySurgery.vue?vue&type=template&id=1f1c5518&scoped=true"
import script from "./VeterinarySurgery.vue?vue&type=script&lang=js"
export * from "./VeterinarySurgery.vue?vue&type=script&lang=js"
import style0 from "./VeterinarySurgery.vue?vue&type=style&index=0&id=1f1c5518&prod&scoped=true&lang=css"
import style1 from "./VeterinarySurgery.vue?vue&type=style&index=1&id=1f1c5518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c5518",
  null
  
)

export default component.exports